/* eslint-disable react/jsx-props-no-spreading */
import moment from 'moment';
import React, { forwardRef } from 'react';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';

import { mergeRefs } from '../../../Utils/merge-refs';

import CalendarIcon from './CalendarIcon';

type Props = {
    value?: string;
    onChange?(date: any): void;
    format?: string;
} & Partial<ReactDatePickerProps>;

const DateInput = forwardRef<HTMLInputElement, any>((props, ref) => {
    const { date, format, onClick, ...rest } = props;
    const asString = date ? moment(date).format(format) : '';
    const inputRef = React.createRef<HTMLInputElement>();

    const onCalendarIconClick = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <div className="date-picker-input" onClick={onClick}>
            <input
                {...rest}
                readOnly
                value={asString}
                type="text"
                className="form-control"
                ref={mergeRefs([inputRef, ref])}
            />
            <CalendarIcon onClick={onCalendarIconClick} />
        </div>
    );
});

const DatePicker = (props: Props) => {
    const { value, onChange, format = 'L', ...rest } = props;
    const valuesAsDate = moment.utc(value).isValid() ? moment(value).toDate() : null;

    return (
        <ReactDatePicker
            {...rest}
            className="date-picker"
            selected={valuesAsDate}
            onChange={onChange}
            disabledKeyboardNavigation
            customInput={<DateInput date={value} format={format} />}
        />
    );
};

export default DatePicker;
